import React from "react";

export function StatusBadge({ status }) {
  if (!status) return null;
  if (status.on_track) {
    return <span className="chip chip-ontrack" data-testid="status-on-track">● On Track</span>;
  }
  return (
    <span className="chip chip-behind" data-testid="status-behind">
      ● Behind: {status.behind_count} book{status.behind_count === 1 ? "" : "s"}
    </span>
  );
}

export function RoleBadge({ role }) {
  const map = {
    admin: { label: "Admin", cls: "chip-behind" },
    project_manager: { label: "Project Manager", cls: "chip-amber" },
    coordinator: { label: "Coordinator", cls: "chip-ontrack" },
    viewer: { label: "Viewer", cls: "" },
  };
  const v = map[role] || { label: role, cls: "" };
  return <span className={`chip ${v.cls}`}>{v.label}</span>;
}

export function ProgressBar({ value }) {
  const v = Math.max(0, Math.min(1, Number(value || 0)));
  const cls = v >= 0.6 ? "" : v >= 0.3 ? "amber" : "behind";
  return (
    <div className="pbar">
      <div className={`pbar-fill ${cls}`} style={{ width: `${v * 100}%` }} />
    </div>
  );
}
